import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const transactionDetailListData = this.props.transactionDetailListData;
    const selectedSearchValues = this.props.selectedSearchValues;
    const totalAmount = this.props.totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return (
      <div>
        <br />
        <h2><center><u>Manual Transaction Details Report</u></center></h2>
        <div>&nbsp;</div>
        <h2><center>{selectedSearchValues.groupName} - {selectedSearchValues.factoryName}</center></h2>
        <h3><center> Route : {selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes'}</center></h3>
        <h3><center> Reg No : {selectedSearchValues.registrationNumber === "" ? 'All Reg No' : selectedSearchValues.registrationNumber}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Route Name</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'center'}>Reg No</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Name</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Transaction Type</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'right'}>Amount</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'} >Effective Date</TableCell>
                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Description</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactionDetailListData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'center'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.name}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.transactionTypeName}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.amount && data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.effectiveDate && data.effectiveDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                        {data.description && data.description !== null ? data.description : '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableCell align={'left'} style={{ borderBottom: "1px solid black", borderLeft: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }}>Total</TableCell>
                    <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                    </TableCell>
                    <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                    </TableCell>
                    <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", padding: '5px', fontWeight: "bold" }}>
                      {totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                    </TableCell>
                    <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", borderRight: "1px solid black", padding: '5px' }}>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h4><center>*******End of List*******</center></h4>
      </div>
    );

  }

}
